import React from "react";
import rightImg from "images/GermainSiteWeb.jpg";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import CurvedContainer from "../../components/CurvedContainer";
import "../../styles/styles.css";

const PageAbout = () => {
  return (
    <div className="w-screen overflow-x-hidden">
      <BgGlassmorphism />
      <CurvedContainer>
        <div style={{ color: "black" }} className="nc-SectionHero relative">
          {/* Titre collé en haut */}
          <h2 className="text-center text-4xl font-semibold md:text-5xl mt-0 mb-6" style={{ color: "black" }}>
            À propos
          </h2>

          {/* Texte + image côte à côte sans espace */}
          <div className="flex flex-col lg:flex-row items-start text-center lg:text-left w-full px-4 lg:px-0">
            {/* Texte – 70% */}
            <div className="w-full lg:w-[70%] space-y-5 lg:space-y-7">
              <span
                style={{ fontSize: "20px", padding:"10px",color: "black" }}
                className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400"
              >
                Titulaire d’un baccalauréat en informatique de gestion, je suis développeur web fullstack depuis près de 20 ans. Mon parcours m’a permis de travailler sur une grande variété de projets, allant de la conception de systèmes de gestion internes à la création de sites web publics.
                <br></br><br></br>
                Spécialisé en développement backend avec PHP et MySQL, j’ai notamment utilisé le framework CodeIgniter pour structurer mes projets selon l’architecture MVC. Du côté frontend, je maîtrise les technologies essentielles telles que HTML, CSS et JavaScript, et je continue d’enrichir mes compétences en suivant des formations récentes sur React, Node.js et les API RESTful.
                <br></br><br></br>
                Curieux, débrouillard et persévérant, j’aime relever des défis techniques et proposer des solutions innovantes qui améliorent l’efficacité et l’expérience utilisateur. Passionné par l’évolution constante du domaine des technologies, je place la formation continue au cœur de ma pratique.
                <br></br><br></br>
                Prêt à m’investir pleinement dans de nouveaux projets, j’ai hâte de mettre mon expertise au service de votre entreprise.
              </span>
            </div>

            {/* Image – pas coupée, ajustée à la hauteur dispo */}
            <div className="w-full lg:w-[30%] flex justify-start mt-6 lg:mt-0">
              <img
                src={rightImg}
                alt="Portrait"
                style={{
                  borderRadius: "25px",
                  maxHeight: "100%",
                  height: "70vh",
                  objectFit: "contain"
                }}
              />
            </div>
          </div>
        </div>
      </CurvedContainer>
    </div>
  );
};

export default PageAbout;
